import React, { useEffect, useRef, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Stack } from '@mui/material';
import JumboCardQuick from '@jumbo/components/JumboCardQuick';
import JumboDemoCard from '@jumbo/components/JumboDemoCard';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import { LoadingButton } from '@mui/lab';
import TableSkeleton from 'app/shared/widgets/TableSkeleton';

const GroupHead = () => {
  const [disbleButton, setDisbleButton] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const swal =useSwalWrapper()
  // [
  //   { "id":1, "GROUP_TYPE": "ASSETS", "GROUP_NAME": "Cash and Cash Equivalents", "ORD": 1 },
  //   { "id":2, "GROUP_TYPE": "ASSETS", "GROUP_NAME": "Accounts Receivable", "ORD": 2 },
  //   { "id":3, "GROUP_TYPE": "LIABILITY", "GROUP_NAME": "Accounts Payable", "ORD": 3 },
  //   { "id":4,"GROUP_TYPE": "INCOME", "GROUP_NAME": "Sales Revenue", "ORD": 4 },
  //   { "id":5,"GROUP_TYPE": "EXPENSE", "GROUP_NAME": "Operating Expenses", "ORD": 5 },
  //   { "id":6,"GROUP_TYPE": "INCOME", "GROUP_NAME": "Other Income", "ORD": 6 }
  // ]
  let Group_Type_value_opt=['LIABILITY','ASSETS', 'INCOME', 'EXPENSE']
  const fetchHeadDetail = async()=>{
    data && setData(null)
    setDisbleButton(true)
    await jwtAuthAxios.get('/acc/groups').then(res =>{
      setData(res.data)
      setDisbleButton(false)
    }).catch(r=>swal.fire({
      icon: 'error',
      text: 'Internal server Error',
    }))
  }
  useEffect(fetchHeadDetail,[])
  const columns = [
    { field: "GROUP_TYPE", headerName: "Group Type",width:((window.innerWidth-90)*15)/100, type: 'singleSelect', valueOptions:Group_Type_value_opt,editable: true},
    { field: "GROUP_NAME", headerName: "Group Name",flex:1,width:((window.innerWidth-90)*72)/100, type: "text" ,editable: true},
    { field: "ORD", headerName: "Order", editable: true,width:((window.innerWidth-90)*10)/100,type: "number" }
  ];
  const addnewRow =()=>{
    data?.length >= 1 ? setData([...data,{ "id":(data?.length||0)+1,GROUP_TYPE: "ASSETS", "GROUP_NAME": "", "ORD": 0 }]) :setData([{ "id":1,GROUP_TYPE: "ASSETS", "GROUP_NAME": "", "ORD": 0 }])
  }
  const handleEditCellChangeCommit = (params) => {
    const updatedData = data.map((row) =>
      row.id === params.id ? { ...row, [params.field]: params.props.value } : row
    );
    setData(updatedData);
  };
  const apiRef = useRef();

  const handleButtonClick = async (props) => {
    // Get all promises for updating rows
    setTimeout(async()=>{

    const updatedRows = await Promise.all(
      data.map(async (row) => {
        if (row.id === props.id) {
          const updatedCellValue = await apiRef.current.getCellValue(props.id, props.field);
          return { ...row, [props.field]: updatedCellValue };
        }
        return row;
      })
    );
    // console.log(updatedRows);
    setData(updatedRows);
    setDisbleButton(false)
  },100);
    // Update the state or perform other operations with updatedRows
  };
  
  const saveDataHandler= async()=>{
    setLoading(false)
    await jwtAuthAxios.post('/acc/groups',{"groups":data}).then(res=>{
      swal.fire({
        icon: 'success',
        text: res.data.message,
      });
      fetchHeadDetail()
    }).catch(e => {
      swal.fire({
        icon: 'error',
        text: 'Internal server Error',
      });    
      }).finally(e=>{
        setLoading(false)
      });    
  }

  return (
    <JumboCardQuick  action={<Stack direction={"row"} justifyContent={'end'} spacing={2}><Button variant='contained' onClick={addnewRow}>Add new</Button><LoadingButton disabled={disbleButton} loading={loading} variant='contained' onClick={saveDataHandler}>Save</LoadingButton></Stack>} sx={{p:0}} title={'Group Head'} >

    <Paper elevation={0} sx={({backgroundColor: theme => theme.palette.action.hover,p:0})}>
    {!Boolean(data) ? <TableSkeleton/>: <DataGrid
        rows={data||[]}
        columns={columns}
        pageSize={5}
        apiRef={apiRef}
        density='compact'
        getRowId={(row) => row.id}
        rowsPerPageOptions={[50, 100, 200]}
        sx={{p:0,fontSize:'16px'}}
        onCellEditStart={(pams)=>setDisbleButton(true)}
        onCellEditStop={handleButtonClick}
        disableRowSelectionOnClick
        />}
    </Paper>
    </JumboCardQuick>

  );
};
GroupHead.Modulename = 'GroupHead';

export default GroupHead;

